// extracted by mini-css-extract-plugin
export default {"mapDisplay":"MapDisplay_mapDisplay__9JdeQ","mapContainer":"MapDisplay_mapContainer__hxfzt","noCoordinates":"MapDisplay_noCoordinates__wf1U7"};